export default __webpack_public_path__ + "static/media/welcomeLandingbg-fsi.ce1e86d3.png";